import React from 'react';
import { Box, Typography, IconButton, Divider } from '@mui/material';
import { Edit } from '@mui/icons-material';

/**
 * Composed SettingsCard component
 * Standardized card component for settings page sections
 */
const SettingsCard = ({ 
  title, 
  children,
  onEdit,
  endActions,
  sx = {},
  ...props 
}) => {
  return (
    <Box 
      sx={{ 
        mb: 6,
        backgroundColor: '#ffffff',
        padding: 4,
        margin: 1,
        borderRadius: 2,
        ...sx,
      }}
      {...props}
    >
      {/* Header with title and edit icon */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
        }}
      >
        <Typography
          variant="h5"
          component="h2"
          sx={{
            fontWeight: 700,
            color: '#000000',
          }}
        >
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {endActions}
          {onEdit && (
            <IconButton
              size="small"
              onClick={onEdit}
              sx={{
                color: '#666666',
              }}
            >
              <Edit fontSize="small" />
            </IconButton>
          )}
        </Box>
      </Box>
      
      {/* Divider */}
      <Divider sx={{ mb: 3 }} />
      
      {/* Content */}
      {children}
    </Box>
  );
};

export default SettingsCard;

